var exports = {
  "J": "CommunityFooter__cRboXI",
};

module.exports = exports;
